// src/api.ts
import axiosInstance from "../../api/axiosConfig";
import { resourcesFindAllResponse } from "./interfaces";

const path = "/resource";

export const getCars = async (): Promise<resourcesFindAllResponse> => {
  try {
    const response = await axiosInstance.post<resourcesFindAllResponse>(
      path + "/find_allFO/v2",
      {
        cantidad_max: "0",
        Language: "ES",
        filters: [
          {
            campo: "IdOrgV",
            operador: "EQ",
            tipo: "string",
            valor1: "TRC",
            valor2: ""
          },
          {
            campo: "Activo",
            operador: "EQ",
            tipo: "boolean",
            valor1: "true",
            valor2: ""
          }
        ]
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

// Ejemplo de función para crear un producto
// export const createProduct = async (productData: Omit<Product, 'id'>): Promise<Product> => {
//   try {
//     const response = await axiosInstance.post<Product>('/products', productData);
//     return response.data;
//   } catch (error) {
//     console.error('Error creating product:', error);
//     throw error;
//   }
// };
